import { render, staticRenderFns } from "./InterfaceCloseButton.vue?vue&type=template&id=f51442e6&scoped=true&"
import script from "./InterfaceCloseButton.vue?vue&type=script&lang=js&"
export * from "./InterfaceCloseButton.vue?vue&type=script&lang=js&"
import style0 from "./InterfaceCloseButton.vue?vue&type=style&index=0&id=f51442e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f51442e6",
  null
  
)

export default component.exports